/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Activation_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Activation was successful. Please restart the program." |
*
* @param {Login_Offline_Activation_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activation_success_toast = /** @type {((inputs?: Login_Offline_Activation_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activation_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activation reussie. Veuillez redemarrer le programme.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Aktivierung war erfolgreich. Bitte starten Sie das Programm neu.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attivazione avvenuta con successo. Riavviare il programma.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Активация прошла успешно. Пожалуйста, перезапустите программу.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La activación se realizó correctamente. Reinicie el programa.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("激活成功。请重启程序。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクティベーションに成功しました。プログラムを再起動してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सक्रियण सफल रहा। कृपया प्रोग्राम को पुनः आरंभ करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A ativação foi bem-sucedida. Reinicie o programa.")
	return /** @type {LocalizedString} */ ("Activation was successful. Please restart the program.")
});